import gql from 'graphql-tag';
import { IntegrationDefinition } from '@jupiterone/jupiter-types';
import { createUseQueryHook } from '@jupiterone/jupiter-web-toolkit';
import { configFieldRecursiveFragment } from '@jupiterone/jupiter-web-toolkit/src/integrations/graphql';

export interface FindIntegrationDefinitionQueryData {
  findIntegrationDefinition: IntegrationDefinition | null;
}

export interface FindIntegrationDefinitionQueryVariables {
  integrationType: string;
}

export const FindIntegrationDefinitionQuery = gql`
  query FindIntegrationDefinition($integrationType: String!) {
    findIntegrationDefinition(integrationType: $integrationType) {
      id
      name
      type
      title
      integrationType
      integrationClass
      oAuth {
        oAuthUrlGeneratorPath
      }
      offsiteUrl
      offsiteButtonTitle
      offsiteStatusQuery
      ...configFieldsRecursive
    }
  }
  ${configFieldRecursiveFragment}
`;

export const useFindIntegrationDefinitionQuery = createUseQueryHook<
  FindIntegrationDefinitionQueryData,
  FindIntegrationDefinitionQueryVariables
>(FindIntegrationDefinitionQuery);
